import Button from "components/Button";
import Modal from "components/Modal";
import { ExclamationSVGIcon } from "components/SVGIcons";
import {
  IDocumentReviewAttachment,
  getMissingDocumentReviewLabels
} from "./documentReviewEligibility";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  attachments: IDocumentReviewAttachment[];
  isFuelAdvance?: boolean;
}

// Names the documents that are actually missing rather than a fixed pair, because which BOL is
// required depends on the fuel advance (HP-9251). Lifted out of the Request Pay documents step so
// the edit screen tells a carrier the same thing in the same words.
export default function DocumentReviewRequirementModal({
  isOpen,
  onClose,
  attachments,
  isFuelAdvance = false
}: Readonly<IProps>) {
  const missing = getMissingDocumentReviewLabels(attachments, isFuelAdvance);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      wrapperClass="!my-auto desktop:!min-h-fit desktop:!w-1/2 text-sm"
      dialogClass="!bg-foreground !px-3 !py-4 gap-2.5"
      closeClass="!top-24 !right-6 !bg-transparent !text-text">
      <div className="flex items-center gap-1 text-xl font-bold text-primary">
        <ExclamationSVGIcon />
        <span>Confirm</span>
      </div>
      <p className="pt-1.5 font-medium">
        To submit for Document Review, you must upload{" "}
        {missing.map((label, index) => (
          <span key={label}>
            {index > 0 ? " and a " : "a "}
            <strong>{label}</strong>
          </span>
        ))}
        {isFuelAdvance
          ? ", to process your fuel advance request."
          : ", unless this is a Truck Order Not Used (TONU)."}
      </p>
      <div className="flex justify-end gap-3">
        <Button variant="outline" rounded className="!w-20 text-sm !h-9 self-end" onClick={onClose}>
          OK
        </Button>
      </div>
    </Modal>
  );
}
